import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useChemicalProductStyles = makeStyles((theme: Theme) =>
  createStyles({
    hazardsList: {
      display: 'flex',
      flexDirection: 'column',
    },
    hazardIcon: {
      backgroundColor: 'transparent',
      width: '60px',
      height: '60px',
      marginRight: '10px',
    },
    companyDetails: {
      display: 'flex',
      flexDirection: 'column',
    },
    protectiveMeasurementsContainer: {
      marginTop: '10px',
      marginBottom: '20px',
      padding: '16px',
      backgroundColor: '#fff3e0',
    },
    protectiveMeasurementsContainerText: {
      paddingTop: '10px',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
    iconList: {
      width: '100%',
    },
    ppeListItem: {
      paddingRight: '15px !important',
      paddingTop: '7px !important',
      paddingBottom: '7px !important'
    }
  })
);
